import axiosInstance from "auth/FetchInterceptor";
import {
  PURCHASE_CATEGORY_ALL,
  PURCHASE_CATEGORY_CREATE,
  PURCHASE_CATEGORY_UPDATE,
  PURCHASE_CATEGORY_DELETE,
} from "constants/ApiConstant";

import { currentStoreParams, withCurrentStore } from "utils/currentStore";

const PurchaseCategoryService = {};

PurchaseCategoryService.getPurchaseCategories = function (params) {
  return axiosInstance.get(PURCHASE_CATEGORY_ALL, {
    params: currentStoreParams(params),
  });
};

PurchaseCategoryService.createPurchaseCategory = function (data) {
  return axiosInstance.post(PURCHASE_CATEGORY_CREATE, withCurrentStore(data));
};

PurchaseCategoryService.updatePurchaseCategory = function (data) {
  return axiosInstance.put(PURCHASE_CATEGORY_UPDATE, withCurrentStore(data));
};

PurchaseCategoryService.deletePurchaseCategory = function (id) {
  return axiosInstance.delete(`${PURCHASE_CATEGORY_DELETE}/${id}`, null);
};

export default PurchaseCategoryService;
